module.exports = __webpack_public_path__ + "img/rapa-logo.3806a11b.jpg";